import React, { useEffect } from 'react';

import { useDealLocationIntent } from '../../hooks/useDealLocationIntent';
import { useResolvedDealLocation } from '../../hooks/useResolvedDealLocation';

interface DealLocationPublisherProps {
    onMapCenterChange: (center: { lat: number; lng: number }) => void;
}

const DealLocationPublisher: React.FC<DealLocationPublisherProps> = ({ onMapCenterChange }) => {
    const intent = useDealLocationIntent();
    const resolved = useResolvedDealLocation(intent);
    
    const lat = resolved.center?.lat;
    const lng = resolved.center?.lng;

    useEffect(() => {
        if (lat != null && lng != null) {
            onMapCenterChange({ lat, lng });
        }
    }, [lat, lng, onMapCenterChange]);

    return null;
};

export default DealLocationPublisher;
